// removed by extract-text-webpack-plugin
module.exports = {"container":"container_2dsxP","mask":"mask_Y-5__","list":"list_16DQ0","title":"title_1YL0V","arrow":"arrow_X1IAG","sub_list":"sub_list_2Vodp","subList":"sub_list_2Vodp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapse/index.scss
// module id = 135
// module chunks = 15